import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter, useLocation } from "react-router-dom";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import FilterBar from "components/Common/FilteringBar";
import TableComponent from "../../components/Common/TableComponent";
import ModalHeaterType from "components/Modals/ModalHeaterType";
import ButtonAdd from "components/Common/ButtonAdd.js";
import { GetData } from "../../helpers/CRUD.js";
import i18next from "i18next";
import * as endpoints from "constants/endpoints";
import { heater_type_types } from "helpers/listsHardcodedData";
import Pagination from "components/Common/Pagination";
import PaginationSelect from "components/Common/PaginationSelect";

const HeaterType = (props) => {
  const [state, setState] = useState({
    pageTitle: i18next.t("link-heater-type-tooltip"),
    heater_types: [],
    isLoading: false,
    isLoaded: false,
    nomEquipmentManufacturers: [],
    page: 1,
    totalCount: null,
    pageSize: 100,
    sorterLabel: "",
    sorterDirection: "",
    isModalOpen: false,
    isActive: true,
    categoryFilter: "",
  });

  const location = useLocation();

  const emitErrors = (error) => {
    props.onErrorsShow(error.body);
  };

  const emitSuccess = (success) => {
    props.onSuccessShow(success);
  };

  const openModal = () => {
    setState((state) => ({ ...state, isModalOpen: !state.isModalOpen }));
    removeBodyCss();
  };

  const closeModal = () => {
    setState((state) => ({ ...state, isModalOpen: false }));
    removeBodyCss();
  };

  const closeAndUpdate = (modalCallback) => {
    setState((state) => ({ ...state, isModalOpen: false }));
    modalCallback();
    removeBodyCss();
  };

  const removeBodyCss = () => {
    document.body.classList.add("no_padding");
  };

  const getAllHeaterTypes = () => {
    setState((state) => ({
      ...state,
      isLoaded: false,
      heater_types: [],
    }));

    let endpointSortAdd = "";

    if (state.sorterLabel !== "") {
      endpointSortAdd = `&orderBy=${state.sorterLabel}_${state.sorterDirection}`;
    }

    const url = `${endpoints.NOMENCLATURE_ENDPOINT}/HeaterType/GetAll?page=${state.page}&size=${state.pageSize}${endpointSortAdd}&isActive=${state.isActive}&filterText=${state.categoryFilter}`;

    GetData(
      url,
      (data) => {
        let tableBodyData;

        if (data) {
          tableBodyData = data.items.map((item) => {
            return {
              id: item.id,
              data: {
                name: item.name,
                type: item.type,
                manufacture: item.equipmentManufacturer
                  ? item.equipmentManufacturer.name
                  : "",
                power: item.pow,
                KcHF: item.kSK1,
                KcHF1: item.kSK2,
                KcHF2: item.kSK3,
                KcHF3: item.kSK4,
                isActive: item.isActive,
              },
            };
          });
        }

        setState((state) => ({
          ...state,
          heater_types: tableBodyData,
          isLoaded: true,
          totalCount: data.totalCount,
        }));
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const updatePage = (page) => {
    setState((state) => ({ ...state, page }));
  };

  const onPageSizeUpdate = (pageSize) => {
    setState((state) => ({ ...state, pageSize, page: 1 }));
  };

  const onSorterClick = (label, direction) => {
    setState((state) => ({
      ...state,
      page: 1,
      sorterLabel: label,
      sorterDirection: direction,
    }));
  };

  useEffect(() => {
    getAllHeaterTypes();
  }, [state.page, state.pageSize, state.isActive, state.categoryFilter]);

  useEffect(() => {
    onPageSizeUpdate(state.pageSize);
  }, [state.isActive, state.categoryFilter]);

  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    setState((state) => ({
      ...state,
      loggedUserType: obj.role,
      isLoading: true,
    }));

    if (location.state) {
      setState((state) => ({ ...state, mode: "edit" }));
    }
  }, []);

  const heater_type_types_list = heater_type_types();

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <CardTitle className="mb-4">{state.pageTitle}</CardTitle>
                </Col>

                <Col md="2" className="ml-auto mr-0">
                  <PaginationSelect
                    pageSize={state.pageSize}
                    index={1}
                    onPageSizeUpdate={onPageSizeUpdate}
                  />
                </Col>

                <Col className="text-right col-md-1">
                  <ButtonAdd
                    onBtnClick={openModal}
                    data-toggle="modal"
                    tooltip="Добави нов вид отоплително тяло"
                  />
                </Col>
              </Row>
              <FilterBar
                tableData={state.heater_types}
                isActive
                filterByCategory
                category="type"
                categories_options={heater_type_types_list}
                state={state}
                setState={setState}
              ></FilterBar>
              <TableComponent
                dataHead={[
                  i18next.t("name"),
                  i18next.t("type"),
                  i18next.t("manufacture"),
                  i18next.t("power"),
                  i18next.t("KcHF"),
                  i18next.t("KcHF1"),
                  i18next.t("KcHF2"),
                  i18next.t("KcHF3"),
                  i18next.t("actions"),
                ]}
                dataBody={state.heater_types}
                sorterData={[
                  "name",
                  "type",
                  "equipmentManufacturer.name",
                  "pow",
                  "kSK1",
                  "kSK2",
                  "kSK3",
                  "kSK4",
                ]}
                onSorterClick={onSorterClick}
                url_path={"heater-type"}
                category={"heater-type"}
                enableLinkView={true}
                isLoading={state.isLoading}
                isLoaded={state.isLoaded}
              />

              <Pagination
                updatePage={updatePage}
                page={state.page}
                totalCount={state.totalCount}
                pageSize={state.pageSize}
              />

              <ModalHeaterType
                isModalOpen={state.isModalOpen}
                closeModal={closeModal}
                update={() => closeAndUpdate(getAllHeaterTypes)}
                emitErrors={emitErrors}
                emitSuccess={emitSuccess}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

HeaterType.propTypes = {
  userProfile: PropTypes.any,
  onGetUserProfile: PropTypes.func,
};

const mapStateToProps = ({ contacts }) => ({
  userProfile: contacts.userProfile,
});

const mapDispatchToProps = (dispatch) => ({
  onGetUserProfile: () => dispatch(getUserProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HeaterType));
